import { baseApi } from "@/redux/api/baseApi";
import { TQueryParam } from "../user/userApi";

const creatorProjectsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreatorProjects: builder.query({
      query: (email) => ({
        url: `/creator-projects/get-assigned-projects?email=${email}`,
        method: "GET",
      }),
      providesTags: ["CreatorProjects"],
    }),
    getAssignedActorV2: builder.query({
      query: ({ orderId, videoId }) => ({
        url: `/single-actor-selection/get-assignment-data-for-creator/${orderId}/${videoId}`,
        method: "GET",
      }),
    }),
    getCreatorProjectsV2: builder.query({
      query: (args) => {
        const params = new URLSearchParams();
        if (args) {
          args.forEach((element: TQueryParam) => {
            params.append(element.name, element.value as string);
          });
        }
        return {
          url: `/creator-projects/get-assigned-projects/v2`,
          method: "GET",
          params,
        };
      },
      providesTags: ["CreatorProjects"],
    }),
    getCreatorProjectDetails: builder.query({
      query: (id) => ({
        url: `/creator-projects/get-project-details/${id}`,
        method: "GET",
      }),
    }),
    getCreatorProjectDetailsV2: builder.query({
      query: (id) => ({
        url: `/creator-projects/get-project-details/v2/${id}`,
        method: "GET",
      }),
      providesTags: (_result, _error, orderId) => [
        { type: "CreatorProjectDetails" as const, id: orderId },
      ],
    }),
  }),
});

export const {
  useGetCreatorProjectsQuery,
  useGetCreatorProjectDetailsQuery,
  useGetCreatorProjectsV2Query,
  useGetCreatorProjectDetailsV2Query,
  useGetAssignedActorV2Query,
} = creatorProjectsApi;
